import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const AideTaskCodesPage = () => {
  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'task', label: 'Task' },
    { key: 'category', label: 'Category' },
    { key: 'duration', label: 'Est. Duration' },
    { key: 'active', label: 'Active' },
  ];

  const formFields = [
    { key: 'code', label: 'Code', type: 'text', required: true },
    { key: 'task', label: 'Task Name', type: 'text', required: true },
    { key: 'category', label: 'Category', type: 'select', required: true, options: [
      { value: 'Personal Care', label: 'Personal Care' },
      { value: 'Homemaking', label: 'Homemaking' },
      { value: 'Companionship', label: 'Companionship' },
      { value: 'Mobility', label: 'Mobility' },
      { value: 'Medication', label: 'Medication' },
    ]},
    { key: 'duration', label: 'Est. Duration (min)', type: 'text', required: false },
    { key: 'active', label: 'Active', type: 'select', required: true, options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]}
  ];

  const initialData = [
    { id: '1', code: 'BATH', task: 'Bathing Assistance', category: 'Personal Care', duration: '30', active: 'Yes' },
    { id: '2', code: 'DRESS', task: 'Dressing Assistance', category: 'Personal Care', duration: '15', active: 'Yes' },
    { id: '3', code: 'GROOM', task: 'Grooming/Hygiene', category: 'Personal Care', duration: '15', active: 'Yes' },
    { id: '4', code: 'MEAL', task: 'Meal Preparation', category: 'Homemaking', duration: '45', active: 'Yes' },
    { id: '5', code: 'LAUND', task: 'Laundry', category: 'Homemaking', duration: '30', active: 'Yes' },
    { id: '6', code: 'LIGHT', task: 'Light Housekeeping', category: 'Homemaking', duration: '30', active: 'Yes' },
    { id: '7', code: 'TRANS', task: 'Transfer Assistance', category: 'Mobility', duration: '10', active: 'Yes' },
    { id: '8', code: 'AMBUL', task: 'Ambulation Assistance', category: 'Mobility', duration: '15', active: 'Yes' },
    { id: '9', code: 'MEDRM', task: 'Medication Reminder', category: 'Medication', duration: '5', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="Aide Task Codes"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Task"
      formFields={formFields}
      apiEndpoint="/setup/aide-task-codes"
    />
  );
};

export default AideTaskCodesPage;
